import React from 'react';
import { AlertCircle } from 'lucide-react';

export const UnavailableDataBadge: React.FC = () => (
  <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs bg-gray-100 text-gray-600">
    <AlertCircle className="w-3 h-3" />
    Não disponível
  </span>
);